import _ from 'lodash';
import { getChartType } from '../core/chart-model-utils';
import { configOptions } from '../core/chart-type-specification-service';
import { getResponsiveBreakpoint, ScreenSizeClass, } from '../core/scaling-service';
import { getEnvFlags } from '../env';
import { ChartType } from '../types';
import { discardConfigOverrides } from './blink-highchart-customisation-util';
import { BuildHighchartStyleConfig, castAxisConfig, } from './highchart-theme-screen-util';
import { isNumberInfinite } from '../components/kpi/kpi-utils';
export function getStackedBarStackedLabelsY() {
    const currentBreakpoint = getResponsiveBreakpoint();
    const screenSizeClass = currentBreakpoint.screenSizeClass || ScreenSizeClass.HD;
    switch (screenSizeClass) {
        case ScreenSizeClass.HD:
            return 4;
        case ScreenSizeClass.FHD:
            return 6;
        case ScreenSizeClass.QHD:
            return 8;
        case ScreenSizeClass.UHD:
            return 16;
        default:
            return null;
    }
}
function getBarChartScreenConfig(styleConfig, shouldScale) {
    delete styleConfig.config.xAxis.labels.y;
    _.set(styleConfig.config, 'yAxis.title.margin', styleConfig.config.xAxis.title.margin);
    styleConfig.config.xAxis.title.margin = undefined;
    if (shouldScale) {
        _.set(styleConfig.config, 'yAxis.stackLabels.y', getStackedBarStackedLabelsY());
    }
    return styleConfig;
}
function setSpiderWebChartScreenConfig(styleConfig) {
    delete styleConfig.config.xAxis.labels.y;
    return styleConfig;
}
export function getStackedColumnChartYStackLabel() {
    const currentBreakpoint = getResponsiveBreakpoint();
    const screenSizeClass = currentBreakpoint.screenSizeClass || ScreenSizeClass.HD;
    switch (screenSizeClass) {
        case ScreenSizeClass.HD:
            return 40;
        case ScreenSizeClass.FHD:
            return 50;
        case ScreenSizeClass.QHD:
            return 60;
        case ScreenSizeClass.UHD:
            return 100;
        default:
            return null;
    }
}
function getStackedColumnChartConfig(styleConfig, shouldScale, hasNegativeDataPoints) {
    let xAxisLabelStyleOverride;
    if (hasNegativeDataPoints) {
        xAxisLabelStyleOverride = {
            ...styleConfig.config.xAxis.labels,
            y: 40,
        };
        _.set(styleConfig.config, 'xAxis.labels', xAxisLabelStyleOverride);
    }
    if (shouldScale) {
        const yStackLabelOffset = getStackedColumnChartYStackLabel();
        xAxisLabelStyleOverride = {
            ...styleConfig.config.xAxis.labels,
            y: yStackLabelOffset,
        };
        _.set(styleConfig.config, 'xAxis.labels', xAxisLabelStyleOverride);
        _.set(styleConfig.config, 'yAxis.stackLabels.y', 0);
    }
    return styleConfig;
}
export function getHighchartScreenConfig(width, defaultScreenConfig = {}, axisDetails = { x: {}, y: {} }, shouldScale, chartModel, dataModel, enablePiechartAnimation = true, height) {
    let styleConfig = BuildHighchartStyleConfig(width, defaultScreenConfig, axisDetails, shouldScale, chartModel, dataModel, enablePiechartAnimation, height);
    const chartType = getChartType(chartModel);
    const hasNegativeDataPoints = [dataModel.minColumnValues[0], dataModel.maxColumnValues[0]].some(values => values.some(val => val < 0 && !isNumberInfinite(val)));
    if (chartType === ChartType.Bar || chartType === ChartType.StackedBar) {
        styleConfig = getBarChartScreenConfig(styleConfig, shouldScale);
    }
    if (chartType === ChartType.SpiderWeb) {
        setSpiderWebChartScreenConfig(styleConfig);
    }
    if (chartType === ChartType.LineStackedColumn ||
        chartType === ChartType.StackedColumn) {
        getStackedColumnChartConfig(styleConfig, shouldScale, hasNegativeDataPoints);
    }
    if (!configOptions(getChartType(chartModel), chartModel)
        .allowedConfigurations.showAxes) {
        delete styleConfig.config.xAxis;
        delete styleConfig.config.yAxis;
    }
    if (getEnvFlags().isHighchartCustomisationEnabled &&
        configOptions(chartType, null).allowedConfigurations
            .allowChartCustomisation) {
        discardConfigOverrides(chartModel, styleConfig.config);
    }
    return castAxisConfig(styleConfig, axisDetails);
}
export function getSankeyChartScreenConfig(shouldScale) {
    let screenSizeClass = ScreenSizeClass.HD;
    if (shouldScale) {
        const currentBreakpoint = getResponsiveBreakpoint();
        screenSizeClass = currentBreakpoint.screenSizeClass;
    }
    if (screenSizeClass === ScreenSizeClass.HD) {
        return {
            fontSize: '12px',
        };
    }
    if (screenSizeClass === ScreenSizeClass.FHD) {
        return {
            fontSize: '16px',
        };
    }
    if (screenSizeClass === ScreenSizeClass.QHD) {
        return {
            fontSize: '24px',
        };
    }
    if (screenSizeClass === ScreenSizeClass.UHD) {
        return {
            fontSize: '48px',
        };
    }
    return null;
}
export function getGeoMapScreenConfig(shouldScale, chartType) {
    let screenSizeClass = ScreenSizeClass.HD;
    if (shouldScale) {
        const currentBreakpoint = getResponsiveBreakpoint();
        screenSizeClass = currentBreakpoint.screenSizeClass;
    }
    const fontFamily = 'Optimo-Plain,Helvetica Neue,Helvetica,Arial,sans-serif';
    if (screenSizeClass === ScreenSizeClass.HD) {
        return {
            fontSize: `14px ${fontFamily}`,
            strokeWidth: configOptions(chartType, null).allowedConfigurations
                .strokeWidth,
        };
    }
    if (screenSizeClass === ScreenSizeClass.FHD) {
        return {
            fontSize: `16px ${fontFamily}`,
            strokeWidth: 2,
        };
    }
    if (screenSizeClass === ScreenSizeClass.QHD) {
        return {
            fontSize: `24px ${fontFamily}`,
            strokeWidth: 4,
        };
    }
    if (screenSizeClass === ScreenSizeClass.UHD) {
        return {
            fontSize: `48px ${fontFamily}`,
            strokeWidth: 6,
        };
    }
    return null;
}
//# sourceMappingURL=chart-theme-screen-service.js.map